import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{ref:"r_region",attrs:{"disabled":!_vm.req.filter.hosp,"clearable":_vm.req.filter.hosp,"color":"teal","label":"Region","items":_vm.getReqRegions,"auto-select-first":"","item-text":"city_region","autocomplete":"nope"},on:{"change":function($event){return _vm.handleChangeReqRegion($event)}},model:{value:(_vm.reqRegion),callback:function ($$v) {_vm.reqRegion=$$v},expression:"reqRegion"}})
}
var staticRenderFns = []

export { render, staticRenderFns }